module.exports = __webpack_public_path__ + "img/caress.0bd88677.jpg";